<div class="splash-content flex-layout-column flex-center-center">
  <div class="splash-logos flex-layout-row flex-center-center">
    <img [src]="BRAND.logo.main" [alt]="BRAND.name"/>
    <app-icon *ngIf="!error" name="arrow-alt-circle-right" class="success-text" aria-hidden="true"></app-icon>
    <app-icon *ngIf="error" name="times-circle" class="error-text" aria-hidden="true"></app-icon>
    <img [src]="website?.logo" alt="external website" onerror="this.src='./assets/common/globe.webp'"/>
  </div>
  <div class="information-with-icon">
    <app-icon *ngIf="!error" name="info" class="success-text" size="lg" fixedWidth aria-hidden="true"></app-icon>
    <p>
      {{ info }}
    </p>
    <br/>
    <p>
      {{ getRedirectText( error ) }}
      <br/>
      <a (click)="redirect()" [class]="error ? ThemeColorSettings.red : ThemeColorSettings.blue"
         class="theme-color-link">
        {{ href }}
      </a>
    </p>
  </div>
  <div class="external-component-button-wrapper">
    <oth-button [routerLink]="URLS.root" text="Home"></oth-button>
    <oth-button (click)="redirect()" text="Proceed"></oth-button>
  </div>
</div>
